import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Positions from "@/pages/Positions";
import Candidates from "@/pages/Candidates";
import CandidateDetail from "@/pages/CandidateDetail";
import ReviewQueue from "@/pages/ReviewQueue";
import Upload from "@/pages/Upload";
import Architecture from "@/pages/Architecture";
import Analytics from "@/pages/Analytics";
import NewPosition from "@/pages/NewPosition";
import PositionDetail from "@/pages/PositionDetail";
import SubmissionPacket from "@/pages/SubmissionPacket";
import Team from "@/pages/Team";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[hsl(var(--teal))] font-head">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function ProtectedBare({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[hsl(var(--teal))] font-head">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[hsl(var(--teal))] font-head">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Layout><div className="p-8"><h1 className="font-head text-2xl font-bold">Access restricted</h1><p className="text-muted-foreground mt-2">Team management is available to administrators only.</p></div></Layout>;
  return <Layout>{children}</Layout>;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/positions" element={<Protected><Positions /></Protected>} />
      <Route path="/positions/new" element={<Protected><NewPosition /></Protected>} />
      <Route path="/positions/:id" element={<Protected><PositionDetail /></Protected>} />
      <Route path="/candidates" element={<Protected><Candidates /></Protected>} />
      <Route path="/candidates/:id" element={<Protected><CandidateDetail /></Protected>} />
      <Route path="/review" element={<Protected><ReviewQueue /></Protected>} />
      <Route path="/upload" element={<Protected><Upload /></Protected>} />
      <Route path="/architecture" element={<Protected><Architecture /></Protected>} />
      <Route path="/team" element={<AdminOnly><Team /></AdminOnly>} />
      <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
      <Route path="/packet/:candidateId/:positionId" element={<ProtectedBare><SubmissionPacket /></ProtectedBare>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Router />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
